/** What the app says about a typed contract number it cannot show (pure: no I/O). */
const clean = (no) => String(no === null || no === undefined ? '' : no).trim().toUpperCase();

/** A number that matches no contract anywhere (never a guess at another contract). */
export const contractNotFoundText = (no) => `No contract ${clean(no)} found - check the number.`;

/** The stores could not be read: not the same as "no such contract". */
export const contractUncheckedText = (no) => `Contract ${clean(no)} could not be checked - try again in a moment.`;
